/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useRef, useState } from "react";
import { toast } from "react-toastify";
import AuthServices from "../../services/authServices";
import { validateEmail } from "../../utils/utils";
import { AuthContext } from "../../context/authContext";
import { useLocation, useNavigate } from "react-router";
import AdminLayout from "../../components/layouts/adminLayout";
import ClientCaptcha from "react-client-captcha";
import { ROLES } from "../../constant/roles";
import NormalFooter from "../../components/Footer/NormalFooter";
import RecaptchaV3 from '../../components/RecaptchaV3';
import { decodeToken, verifyToken } from "../../utils/jose";

const initial = {
  email: "",
  password: "",
  captcha: "",
};
const Login = () => {
  const { state } = useLocation();
  const [loginData, setLoginData] = useState(initial);
  const [isPasswordShow, setIsPasswordShow] = useState(false);
  const auth = useContext(AuthContext);
  const [errors, setErrors] = useState({});
  const [captcha, setCaptcha] = useState({});
  const navigate = useNavigate();
  const captchaRef = useRef();
  // const reloadCaptcha = () => {
  // captchaRef?.current.generateCaptcha();
  // };
  const handleChange = (event) => {
    setLoginData((prevState) => {
      return {
        ...prevState,
        [event.target.name]: event.target.value,
      };
    });
  };
  const [loading, setLoading] = useState(false);

  const validate = () => {
    const error = {};
    if (!loginData?.email) error.email = "Please enter your e-mail ID";
    else if (!validateEmail(loginData?.email)) {
      error.email = "Please enter valid e-mail ID";
    }
    if (!loginData?.password) {
      error.password = "Please enter your password";
    }
    // if (!loginData?.captcha) {
    //   error.captcha = "Please enter the captcha";
    // } else if (loginData?.captcha && loginData?.captcha !== captcha) {
    //   error.captcha = "Captcha doesn't match";
    // }
    if (!loginData?.password) {
      error.password = "Please enter your password";
    } 
    
    // else if (loginData?.password.length > 12) {
    //   error.password = "Password must not exceed 12 characters";
    // }

    return error;
  };

  useEffect(() => {
    if (AuthServices.handleAuthentication())
      navigate("/system-admin/license-master");
  }, []);

  const submitForm = async (e) => {
    e.preventDefault();
    const errors = validate();
    if (Object.keys(errors).length) {
      setErrors(errors);
      // reloadCaptcha();
      setLoginData({ ...loginData });
      return;
    }
    setErrors({});
    const recaptchaToken = await new Promise((resolve) => {
      if (!window.grecaptcha) { resolve(''); return; }
      window.grecaptcha.ready(async () => {
        try {
          const token = await window.grecaptcha.execute(process.env.REACT_APP_RECAPTCHA_SITE_KEY, { action: 'submit' });
          resolve(token);
        } catch {
          resolve('');
        }
      });
    })

    const formData = new FormData();
    formData.append("email", loginData.email);
    formData.append("password", loginData.password);
    formData.append("recaptcha_token", recaptchaToken);
    const payload = { email: loginData.email, password: loginData.password, recaptcha_token: recaptchaToken };
    setLoading("login");
    const response = await AuthServices.login(payload);
    if (response?.access_token) {
      setLoading(false);
      localStorage.setItem("aparajithaData", JSON.stringify(response));

      if (response?.status === "password_expired") {
        auth.setIsAuthenticated(true);
        auth.setMustChangePassword(true);
        toast.warning(
          response?.message ||
            "Your password has expired. Please change your password to continue."
        );
        navigate("/force-change-password");
        return;
      }

      const responseData = response?.data.split("~");

      // const jwtValue = response?.data;
      const result = await verifyToken(responseData[1],response?.access_token);
      const jwtValue = await verifyToken(responseData[1],responseData[0]);

      if(result?.user_email != jwtValue?.email && result?.user_role_id != jwtValue?.user_role_id)
      {
        setLoading(false);
        toast.error("Invalid credentials or unauthorized role");
        return false;
      }

      auth.setUserId(jwtValue?.id);
      auth.setRoleId(jwtValue?.user_role_id);
      auth.setName(jwtValue?.name);
      auth.setEmail(jwtValue?.email);
      auth.setPhone(jwtValue?.mobile_no);
      auth.setCreatedBy(
        jwtValue?.created_by ? jwtValue?.created_by : ""
      );
      auth.setIsAuthenticated(true);
      auth.setMustChangePassword(false);
      toast.success("Logged in successfully");

      if (state) {
        navigate(state?.from);
      } else {
        switch (jwtValue?.user_role_id) {
          case ROLES.systemAdmin:
            navigate("/system-admin/license-master");
            break;
          case ROLES.allianceManager:
            navigate("/alliance-manager/dashboard");
            break;
          case ROLES.vendor:
            navigate("/vendor/dashboard");
            break;
          case ROLES.executive:
            navigate("/executive/dashboard");
            break;
          case ROLES.fieldExecutive:
            navigate("/field-executive/dashboard");
            break;
          case ROLES.marketing: //18-10-2024 - UI/UX:blog - Subha
            navigate("/marketing/blogs");
            break;
          case ROLES.customerSupport:
            navigate("/customer-support/dashboard");
            break;
          default:
            toast.error("Invalid credentials");
            break;
        }
      }
    } else {
      // reloadCaptcha();
      setLoginData(initial);
    }
    setLoading(false);
  };

  // useEffect(() => {
  //   window.onbeforeunload = function (e) {};
  //   window.onunload = function (e) {};
  //   return () => {
  //     window.onbeforeunload = function (e) {
  //       return "Are you leaving the site?";
  //     };
  //     window.onunload = function (e) {
  //       localStorage.clear();
  //     };
  //   };
  // }, []);

  return (
    <AdminLayout sideMenu={false} footer={false}>
      <div
        style={{
          background: "url(/img/screen-background.png)",
          backgroundRepeat: "no-repeat",
          backgroundSize: "cover",
        }}
        className=" d-flex flex-column justify-content-center  align-items-center h-100 "
      >
        <div className="col-lg-4 col-md-6 col-sm-10">
          <div className="card card-lg">
            <div className="card-body">
              <h2 className="mb-4">Login</h2>
              <form
                onKeyDown={(e) => {
                  if (
                    (e.key === "Enter" || e.key === "NumpadEnter") &&
                    !loading
                  ) {
                    submitForm(e);
                  }
                }}
              >
                <div className="row">
                  <div className="col-sm-12 mb-4 mb-sm-0">
                    <div className="mb-4">
                      <label
                        className="form-label font-md"
                        htmlFor="contactsFormCompany"
                      >
                        Email ID<span style={{ color: "red" }}> *</span>
                      </label>
                      <input
                        type="text"
                        className="form-control "
                        name="email"
                        id="email"
                        placeholder="Enter email ID"
                        value={loginData.email}
                        onChange={handleChange}
                      />
                      {errors?.email && (
                        <div className="text-danger  mt-2 ml-1">
                          {errors?.email}
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="position-relative mb-5">
                  <label
                    className="form-label font-md"
                    htmlFor="contactsFormWorkEmail"
                  >
                    Password<span style={{ color: "red" }}> *</span>
                  </label>
                  <i
                    className={`position-absolute hover:cursor-pointer fa ${isPasswordShow ? "fa-eye" : "fa-eye-slash"
                      }`}
                    style={{
                      right: "10px",
                      top: "60%",
                    }}
                    // onClick={() => setIsPasswordShow(!isPasswordShow)}
                    onMouseOver={() => setIsPasswordShow(true)}
                    onFocus={() => setIsPasswordShow(true)}
                    onMouseOut={() => setIsPasswordShow(false)}
                    onBlur={() => setIsPasswordShow(false)}
                  ></i>
                  <input
                    type={isPasswordShow ? "text" : "password"}
                    className="form-control eyeOne"
                    name="password"
                    placeholder="Enter password"
                    id="contactsFormWorkEmail"
                    aria-label="email@site.com"
                    value={loginData.password}
                    onChange={handleChange}
                    autoComplete="off"
                  />
                  {errors?.password && (
                    <div className="text-danger position-absolute mb-3">
                      {errors?.password}
                    </div>
                  )}
                </div>

                {/* <div className="position-relative mb-5">
                  <ClientCaptcha
                    captchaCode={(code) => {
                      setCaptcha(code);
                      setLoginData({ ...loginData, captcha: "" });
                    }}
                    backgroundColor="#eee"
                    fontColor="red"
                    fontFamily="Latin script"
                    width={120}
                    charsCount={6}
                    ref={captchaRef}
                  />
                  <input
                    type="text"
                    className="form-control mt-3"
                    name="captcha"
                    id="captcha"
                    maxLength={6}
                    value={loginData?.captcha}
                    placeholder="Enter captcha code"
                    onChange={handleChange}
                  />
                  {errors?.captcha && (
                    <div className="text-danger  mt-2 ml-1">
                      {errors?.captcha}
                    </div>
                  )}
                </div> */}
                <RecaptchaV3 />
                <div className="d-grid gap-4">
                  <button
                    type="submit"
                    className="btn btn-primary btn-lg"
                    onClick={!loading ? submitForm : () => { }}
                  >
                    {loading ? "Loading..." : "Submit"}
                  </button>
                </div>
                <div className="text-end font-md">
                  <a
                    href="#"
                    style={{ bottom: 0, right: 0 }}
                    onClick={() => navigate("/forgot")}
                  >
                    Forgot Password
                  </a>
                </div>
              </form>
            </div>
          </div>


        </div>
        {/* <NormalFooter/> */}
      </div>

    </AdminLayout>
  );
};

export default Login;
